import io from 'socket.io-client'
import socketio from '@feathersjs/socketio-client'

const config = {
  transports: ['websocket'],
  path: '/api/ws/',
}

// TODO: move to config
// if (document.location.host.includes('jobcarda')) {
//   config.secure = true
// }

const socket = io(`//${document.location.host}`, config)

export default function() {
  this.configure(socketio(socket, {
    timeout: 14000,
  }))

  // localStorage.debug = 'socket.io'
  // localStorage.debug = '*'

  // socket.on('connection', () => {
  //   console.log('connection-done')
  // })

  // re-authintication on reconnect
  // socket.on('reconnect', () => {
  //   this.authenticate()
  // })
}



// WEBPACK FOOTER //
// ./src/store/client/sockets.js